// UI Components
import { TableSearch } from "ui/components/Table/TableSearch";

// React
import { memo } from "react";

// Services & Constants
import { initialDataWithPagination } from "services/api/consts";

// Local Constants
import { CALCULATION_VEHICLE_GROUP_SEARCH_COLUMNS } from "./consts";

// Types
import { VehicleGroupSearchResultsProps } from "./types";


const VehicleGroupSearchResults: React.FC<VehicleGroupSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  return (
    <>
      <TableSearch
        columns={CALCULATION_VEHICLE_GROUP_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(VehicleGroupSearchResults);
